import Marquee from "react-fast-marquee";
import { Star } from "lucide-react";

const WORDS = [
  "Fresh Ingredients",
  "Fresh From The Oven",
  "Hand-Stretched Dough",
  "Roman-Style Pinsa",
  "Baked Hot",
  "Made With Passion",
];

export default function EditorialMarquee() {
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-black/10 bg-cream py-4 text-ember">
      <Marquee speed={25} gradient={false} pauseOnHover>
        {WORDS.map((w) => (
          <span key={w} className="mx-10 flex items-center gap-10">
            <span className="font-serif text-base italic md:text-lg">{w}</span>
            <Star size={11} className="fill-gold text-gold" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
